import scheduleStyle from "./schedule.module.css"


export async function calendar_setup(props) {
    try {
        const today = window.EventManager.today
        const todayYear = window.EventManager.todayYear
        const todayMonth = window.EventManager.todayMonth
        const todayDate = window.EventManager.todayDate
        const selectDay = window.EventManager.selectDay
        const Set_selectDay = window.EventManager.Set_selectDay

        const selectEevent = window.EventManager.selectEevent

        const schedule = props['schedule']
        const firstDay = new Date(props['firstDay'])
        const lastDay = new Date(props['lastDay'])

        // 행사의 시작일, 종료일
        let startDay = selectEevent['start_day']
        if(startDay === null || startDay === '') {
            startDay = '0'
        }
        let endDay = selectEevent['end_day']
        if(endDay === null || endDay === '') {
            endDay = '0'
        }
        const start_code = Number(startDay.replaceAll("-", ""))
        const end_code = Number(endDay.replaceAll("-", ""))

        const calendar = document.getElementById('calendar_day')
        calendar.innerHTML = ''

        let week = document.createElement('tr')
        week.classList.add(scheduleStyle['weekWrap'])

        const new_selectDay = []

        for(let i=0; i<firstDay.getDay(); i++) {
            const day = document.createElement('td')
            day.classList.add(scheduleStyle['dateWrap'])
            week.append(day)
        }

        for(let nowDay=firstDay; nowDay<=lastDay; nowDay.setDate(nowDay.getDate() + 1)) {
            const day = document.createElement('td')
            day.classList.add(scheduleStyle['dateWrap'])
            day.insertAdjacentHTML(
                'beforeend',
                `
                    <div class=${scheduleStyle['date']}>${String(nowDay.getDate()).padStart(2, '0')}</div>
                `
            )

            const convert_day = `${nowDay.getFullYear()}-${String(nowDay.getMonth() + 1).padStart(2, '0')}-${String(nowDay.getDate()).padStart(2, '0')}`
            const filter_day = schedule.filter(x => x['targetDate'] === convert_day)
            let count = 0
            for(let i=0; i<filter_day.length; i++) {
                if(i < 3) {
                    day.insertAdjacentHTML(
                        'beforeend',
                        `
                            <div class=${scheduleStyle['schedule']}>
                                <div>${filter_day[i]['title']}</div>
                                <div>|</div>
                                <div>${filter_day[i]['targetTime']}(${filter_day[i]['targetNumber']})</div>
                            </div>
                        `
                    )
                }
                else {
                    count++
                }

                if(filter_day.length > 3 && i === filter_day.length - 1) {
                    day.insertAdjacentHTML(
                        'beforeend',
                        `
                            <div class=${scheduleStyle['count']}>+${count}</div>
                        `
                    )
                }
            }
            week.append(day)

            if(
                nowDay.getDay() === 6 ||
                nowDay.getDate() === lastDay.getDate()
            ) {
                calendar.append(week)

                week = document.createElement('tr')
                week.classList.add(scheduleStyle['weekWrap'])
            }

            if(nowDay < today) {
                day.classList.add(scheduleStyle['pastDay'])
            }
            else {
                if(start_code !== 0 && end_code === 0 && nowDay < new Date(startDay)) {
                    day.classList.add(scheduleStyle['pastDay'])
                    continue
                }
                else if(start_code === 0 && end_code !== 0 && nowDay > new Date(endDay)) {
                    day.classList.add(scheduleStyle['pastDay'])
                    continue
                }
                else if(start_code !== 0 && end_code !== 0 && start_code <= end_code) {
                    if(nowDay < new Date(startDay) || nowDay > new Date(endDay)) {
                        day.classList.add(scheduleStyle['pastDay'])
                        continue
                    }
                }

                if(
                    nowDay.getFullYear() === todayYear &&
                    nowDay.getMonth() === todayMonth &&
                    nowDay.getDate() === todayDate
                ) {
                    day.classList.add(scheduleStyle['today'])
                }
                else if(nowDay > today) {
                    day.classList.add(scheduleStyle['futureDay'])
                }

                day.setAttribute('date', nowDay.getDate())
                const this_day = new Date(nowDay)
                const convert_day = `${this_day.getFullYear()}-${String(this_day.getMonth() + 1).padStart(2, '0')}-${String(this_day.getDate()).padStart(2, '0')}`
                day.onclick = function() {
                    select_day({
                        'target': this,
                        'value': convert_day
                    })
                }

                const preSelected = selectDay.filter(x => x['value'] === convert_day)
                if(preSelected.length === 1) {
                    new_selectDay.push({
                        'target': day,
                        'value': convert_day
                    })
                }
            }
        }

        week = calendar.lastElementChild
        for(let i=lastDay.getDay(); i<6; i++) {
            const day = document.createElement('td')
            day.classList.add(scheduleStyle['dateWrap'])
            week.append(day)
        }

        await Set_selectDay([...new_selectDay])

        return true
    }
    catch(error) {
        console.log(error)
    }
}


export function select_day(props) {
    const selectDay = window.EventManager.selectDay
    const Set_selectDay = window.EventManager.Set_selectDay

    const target = props['target']
    const value = props['value']

    const findIndex = selectDay.findIndex(x => x['target'] === target)
    if(findIndex === -1) {
        selectDay.push({
            'target': target,
            'value': value
        })

        Set_selectDay([...selectDay])
    }
    else {
        const new_selectDay = []
        for(let i=0; i<selectDay.length; i++) {
            if(findIndex !== i) {
                new_selectDay.push(selectDay[i])
            }
            else {
                selectDay[i]['target'].classList.remove(scheduleStyle.selectedDay)
            }
        }

        Set_selectDay(new_selectDay)
    }
}


export async function search_day(props) {
    const value = props['value']
    const Set_calendarLoading = props['Set_calendarLoading']

    await Set_calendarLoading(true)

    const searchYear = window.EventManager.searchYear
    const Set_searchYear = window.EventManager.Set_searchYear
    const searchMonth = window.EventManager.searchMonth
    const Set_searchMonth = window.EventManager.Set_searchMonth
    const Set_selectDay = window.EventManager.Set_selectDay

    Set_selectDay([])

    const day = new Date(value)
    Set_searchYear(day.getFullYear())
    Set_searchMonth(day.getMonth())
}


export async function month_setup(props) {
    const value = props['value']
    const Set_calendarLoading = props['Set_calendarLoading']

    const searchYear = window.EventManager.searchYear
    const Set_searchYear = window.EventManager.Set_searchYear
    const searchMonth = window.EventManager.searchMonth
    const Set_searchMonth = window.EventManager.Set_searchMonth
    const Set_selectDay = window.EventManager.Set_selectDay

    const day = new Date(searchYear, searchMonth + value)

    if(day.getFullYear() < 2026) {
        return
    }

    await Set_calendarLoading(true)

    Set_selectDay([])

    Set_searchYear(day.getFullYear())
    Set_searchMonth(day.getMonth())
}